// src/pages/dashboardadmindata/expand/curatedrecipeexpand.jsx
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector }            from "react-redux";
import Chart                                    from "chart.js/auto";
import Modal                                    from "react-bootstrap/Modal";
import { Card, CardBody }                       from "../../../components/card/card.jsx";
import { fetchAdminCuratedRecipesAdditionalData }
  from "../../../actions/dashboardadmin_actions";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

const CuratedRecipeExpand = React.memo(({
  data,
  labels,
  values,
  themeColor,
  themeColorRgb,
  bodyBg
}) => {
  const dispatch      = useDispatch();
  const chartRef      = useRef(null);
  const summaryRef    = useRef(null);
  const modalTableRef = useRef(null);

  const [show, setShow]           = useState(false);
  const [datelabel, setDatelabel] = useState("");

  const {
    curatedRecipesAdditionalData,
    loadingCuratedRecipesAdditionalData,
    curatedRecipesAdditionalDataError
  } = useSelector(state => ({
    curatedRecipesAdditionalData:        state.dashboardadmin.curatedRecipesAdditionalData,
    loadingCuratedRecipesAdditionalData: state.dashboardadmin.loadingCuratedRecipesAdditionalData,
    curatedRecipesAdditionalDataError:   state.dashboardadmin.curatedRecipesAdditionalDataError
  }));

  // 0) Inject global CSS to force consistent font on all table cells & descendants
  useEffect(() => {
    const style = document.createElement("style");
    style.type  = "text/css";
    style.innerHTML = `
      /* Force Inter 14px on all DataTable cells and their children */
      div.dataTables_wrapper table.dataTable tbody tr td,
      div.dataTables_wrapper table.dataTable tbody tr th,
      div.dataTables_wrapper table.dataTable tbody tr td *,
      div.dataTables_wrapper table.dataTable tbody tr th * {
        font-family: "Inter", sans-serif !important;
        font-size:   14px           !important;
        font-weight: 400            !important;
        color: var(--bs-body-color) !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // 1) Chart Over Time
  useEffect(() => {
    if (!chartRef.current) return;
    const chart = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [{
          label: "Curated Recipes Over Time",
          data: values,
          borderColor: themeColor,
          pointBackgroundColor: bodyBg,
          backgroundColor: themeColorRgb,
          borderWidth: 1.5,
          fill: false,
          pointRadius: 4
        }]
      },
      options: { responsive: true, maintainAspectRatio: false }
    });
    return () => chart.destroy();
  }, [labels, values, themeColor, themeColorRgb, bodyBg]);

  // 2) Summary table w/ “View” buttons
  useEffect(() => {
    if (!summaryRef.current) return;
    const dt = $(summaryRef.current).DataTable({
      data: [...(data?.dateswise || [])].reverse(),
      columns: [
        {
          title: "#",
          data: null,
          render: (_d, _t, _r, meta) => meta.row + 1
        },
        { title: "Date",  data: "label" },
        { title: "Count", data: "value" },
        {
          title: "Details",
          data: null,
          render: (_d, _t, row) =>
            `<button class="btn btn-primary btn-sm view-details"
                     data-row='${JSON.stringify(row)}'>
               View
             </button>`
        }
      ],
      destroy: true,
      responsive: true
    });

    $(summaryRef.current)
      .off("click", ".view-details")
      .on("click", ".view-details", function() {
        const row = $(this).data("row");
        const [ , startTime, endTime ] =
          row.Details.match(/\(([^,]+),([^,]+),([^)]+)\)/).slice(1);
        setDatelabel(row.label);
        dispatch(fetchAdminCuratedRecipesAdditionalData(
          Number(startTime),
          Number(endTime)
        ));
        setShow(true);
      });

    return () => dt.destroy();
  }, [data, dispatch]);

  // 3) Modal table from Redux data
  useEffect(() => {
    if (!modalTableRef.current) return;

    const dt = $(modalTableRef.current).DataTable({
      data: curatedRecipesAdditionalData || [],
      columns: [
        { title: "ID",          data: "id" },
        { title: "Name",        data: "name" },
        { title: "Description", data: "description" },
        { title: "Tag Name",    data: "tagName" },
        { title: "Make Count",  data: "makeCount" },
        {
          title: "Created",
          data:  "created",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:  "2-digit",
              day:    "2-digit",
              year:   "numeric",
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            });
          }
        },
        {
          title: "Updated",
          data:  "updated",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:  "2-digit",
              day:    "2-digit",
              year:   "numeric",
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            });
          }
        }
      ],
      destroy:    true,
      responsive: true,
      rowId:      "id"
    });

    return () => dt.destroy();
  }, [curatedRecipesAdditionalData, loadingCuratedRecipesAdditionalData]);


  return (
    <>
      <h1>Curated Recipes</h1>

      <section className="accordion mb-2" id="accordionExample">
        {/* Chart Over Time */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
            >
              Chart Over Time
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse show">
            <div className="accordion-body" style={{ height: '400px', overflow: 'hidden' }}>
              <canvas ref={chartRef} className="w-100" height="450" />
            </div>
          </div>
        </div>

        {/* Details Over Time */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
            >
              Details Over Time
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse show">
            <div className="accordion-body">
              <div className="table-responsive">
                <table
                  ref={summaryRef}
                  className="table table-striped w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={show} fullscreen onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Curated Recipes – {datelabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card>
            <CardBody>
              {loadingCuratedRecipesAdditionalData && <div className="spinner-border" />}
              {curatedRecipesAdditionalDataError && (
                <div className="text-danger">
                  {curatedRecipesAdditionalDataError}
                </div>
              )}
              {!loadingCuratedRecipesAdditionalData && !curatedRecipesAdditionalDataError && (
                <div className="table-responsive">
                  <table
                    ref={modalTableRef}
                    className="table table-striped w-100"
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  );
});

export default CuratedRecipeExpand;
